const dsBridge = require('dsbridge')

export const PLATFORM_TYPE = Object.freeze({
  ANDROID: 'ANDROID',
  IOS: 'IOS',
  H5: 'H5'
})

function isTruthyAppFlag(value) {
  return value === true || value === 'true' || value === 1 || value === '1'
}

function isPlainObject(value) {
  return Object.prototype.toString.call(value) === '[object Object]'
}

function isFormData(value) {
  return typeof FormData !== 'undefined' && value instanceof FormData
}

function isSearchParams(value) {
  return typeof URLSearchParams !== 'undefined' && value instanceof URLSearchParams
}

export function isAppContainer() {
  if (dsBridge && dsBridge.call) {
    try {
      const appFlag = dsBridge.call('sync.isApp', '')

      if (appFlag !== undefined && appFlag !== null && appFlag !== '') {
        return isTruthyAppFlag(appFlag)
      }
    } catch (error) {
      // dsBridge 在纯浏览器环境下可能不可调用，这里回退到浏览器特征判断。
    }
  }

  return !!(
    (typeof window !== 'undefined' && (window._dsbridge || window._dswk)) ||
    (typeof navigator !== 'undefined' &&
      typeof navigator.userAgent === 'string' &&
      navigator.userAgent.indexOf('_dsbridge') !== -1)
  )
}

export function getPlatformType() {
  if (!isAppContainer()) {
    return PLATFORM_TYPE.H5
  }

  if (typeof navigator === 'undefined' || typeof navigator.userAgent !== 'string') {
    return PLATFORM_TYPE.H5
  }

  const ua = navigator.userAgent.toLowerCase()
  if (/iphone|ipad|ipod/.test(ua)) {
    return PLATFORM_TYPE.IOS
  }

  if (/android/.test(ua)) {
    return PLATFORM_TYPE.ANDROID
  }

  return PLATFORM_TYPE.H5
}

export function appendPlatformType(payload, fieldName = 'platform_type') {
  const platformType = getPlatformType()

  if (isFormData(payload)) {
    const currentValue = payload.get(fieldName)
    if (currentValue === null || currentValue === undefined || currentValue === '') {
      payload.append(fieldName, platformType)
    }
    return payload
  }

  if (isSearchParams(payload)) {
    const currentValue = payload.get(fieldName)
    if (currentValue === null || currentValue === undefined || currentValue === '') {
      payload.set(fieldName, platformType)
    }
    return payload
  }

  if (payload === undefined || payload === null) {
    return {
      [fieldName]: platformType
    }
  }

  if (!isPlainObject(payload)) {
    return payload
  }

  if (payload[fieldName] === undefined || payload[fieldName] === null || payload[fieldName] === '') {
    return {
      ...payload,
      [fieldName]: platformType
    }
  }

  return payload
}

export default getPlatformType
